var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClients3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.373,
    height: 40.333,
    viewBox: "0 0 131.373 40.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-1302.627 -10755.334)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "FormPal",
    transform: "translate(1347 10782)",
    fontSize: 21,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FormPal")), /*#__PURE__*/React.createElement("g", {
    id: "logoipsum-280",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 1313.938, 10755.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M9.7,0A6.02,6.02,0,0,0,5.448,1.763L1.763,5.448a6.02,6.02,0,1,0,8.514,8.514l2.549-2.549s0,0,0,0l7.426-7.426a2.876,2.876,0,0,1,4.767,1.141l2.344-2.344a6.021,6.021,0,0,0-9.335-1.022L8.053,11.738A2.875,2.875,0,0,1,3.987,7.672L7.672,3.987a2.876,2.876,0,0,1,4.767,1.141l2.344-2.344A6.016,6.016,0,0,0,9.7,0Z",
    fill: "#394149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M32.909,11.738A2.876,2.876,0,0,1,28.142,10.6L25.8,12.94a6.021,6.021,0,0,0,9.334,1.021l9.974-9.974a2.875,2.875,0,0,1,4.066,4.066l-3.685,3.685A2.876,2.876,0,0,1,40.721,10.6L38.378,12.94a6.021,6.021,0,0,0,9.335,1.021L51.4,10.277a6.02,6.02,0,1,0-8.514-8.514Z",
    transform: "translate(-12.276)",
    fill: "#394149"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients3);
export default __webpack_public_path__ + "static/media/clients3.8d3021883353d31eec8d96b51ed4ab24.svg";
export { ForwardRef as ReactComponent };